import React from 'react';

/**
 * Badge niveau avec couleur selon le palier
 * Niv 1-4:  gris  (Débutant)
 * Niv 5-9:  vert  (Intermédiaire)
 * Niv 10-19: bleu (Confirmé)
 * Niv 20-29: orange (Avancé)
 * Niv 30-49: or   (Expert)
 * Niv 50+:  violet (Légende)
 */
function LevelBadge({ level = 1, prestige = 0, size = 'md', className = '' }) {
  const getTier = (lvl) => {
    if (lvl >= 50) return { color: '#a855f7', bg: 'rgba(168,85,247,0.2)',  border: 'rgba(168,85,247,0.5)', label: 'Légende',        glow: '0 0 10px rgba(168,85,247,0.6)' };
    if (lvl >= 30) return { color: '#f0b429', bg: 'rgba(240,180,41,0.2)',  border: 'rgba(240,180,41,0.5)', label: 'Expert',          glow: '0 0 8px rgba(240,180,41,0.5)' };
    if (lvl >= 20) return { color: '#f97316', bg: 'rgba(249,115,22,0.2)',  border: 'rgba(249,115,22,0.5)', label: 'Avancé',          glow: '0 0 6px rgba(249,115,22,0.4)' };
    if (lvl >= 10) return { color: '#3b82f6', bg: 'rgba(59,130,246,0.2)',  border: 'rgba(59,130,246,0.5)', label: 'Confirmé',        glow: '0 0 6px rgba(59,130,246,0.4)' };
    if (lvl >= 5)  return { color: '#22c55e', bg: 'rgba(34,197,94,0.2)',   border: 'rgba(34,197,94,0.5)',  label: 'Intermédiaire',   glow: '0 0 4px rgba(34,197,94,0.3)' };
    return           { color: '#94a3b8', bg: 'rgba(148,163,184,0.15)', border: 'rgba(148,163,184,0.3)', label: 'Débutant',         glow: 'none' };
  };

  const sizeMap = {
    xs: { fontSize: '0.65rem', padding: '1px 6px' },
    sm: { fontSize: '0.7rem',  padding: '2px 7px' },
    md: { fontSize: '0.8rem',  padding: '3px 9px' },
    lg: { fontSize: '0.95rem', padding: '4px 12px' },
  };

  // Un joueur qui a prestigé est forcément plus avancé qu'un niveau 50 "normal"
  // (il a déjà franchi le plafond au moins une fois) — on force donc le palier
  // Légende même si son niveau affiché, remis à 1, ne le suggère pas.
  const tierLevel = prestige > 0 ? Math.max(level, 50) : level;
  const { color, bg, border, glow } = getTier(tierLevel);
  const { fontSize, padding } = sizeMap[size] || sizeMap.md;

  return (
    <span
      className={className}
      title={prestige > 0 ? `Prestige ${prestige} — ${getTier(tierLevel).label}` : getTier(tierLevel).label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        fontFamily: "'Rajdhani', sans-serif",
        fontWeight: 700,
        fontSize,
        padding,
        borderRadius: 6,
        border: `1px solid ${border}`,
        background: bg,
        color,
        boxShadow: glow,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
      }}
    >
      {prestige > 0 && (
        <span style={{ color: '#f0b429' }}>🌟{prestige}</span>
      )}
      <span style={{ opacity: 0.7, fontSize: '0.75em' }}>NIV</span>
      <span>{level}</span>
    </span>
  );
}

export default LevelBadge;
